import { Injectable } from '@angular/core';
import { SidebarDtoV2 } from '@osos/shared/api';

import { NavigationPresenterModelV2 } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';

import { NavigationParserV2Service } from '../../parsers';
import { ParserFactory } from '../../services';

@Injectable()
export class NavigationFactoryV2Service extends FactoryBase<
  SidebarDtoV2,
  NavigationPresenterModelV2
> {
  constructor(
    parserFactory: ParserFactory,
    parseV1: NavigationParserV2Service,
  ) {
    super(parserFactory);
    parserFactory.register(parseV1);
  }
  createDataModel(presenter: NavigationPresenterModelV2): SidebarDtoV2 {
    const parser = this.getParser(
      SidebarDtoV2,
      NavigationPresenterModelV2,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }
  createPresenterModel(model: SidebarDtoV2 | any): NavigationPresenterModelV2 {
    const parser = this.getParser(
      SidebarDtoV2,
      NavigationPresenterModelV2,
      model.specificationVersion,
    );
    const result = parser?.getPresenterModel(model);
    return result;
  }
}
